<div class="page biggest-container">
  <p>Taper Le code</p>
  <div class="content" id="verification-input">
    <input
      #Firstkey
      id="key1"
      type="password"
      maxlength="1"
      pattern="[0-9]"
      (input)="onKeyInput(1)"
      [(ngModel)]="key1"
    />
    <input
      #Secondkey
      type="password"
      maxlength="1"
      (input)="onKeyInput(2)"
      [(ngModel)]="key2"
    />
    <input
      #Thirdkey
      type="password"
      pattern="[0-9]"
      (input)="onKeyInput(3)"
      [(ngModel)]="key3"
    />
    <input
      #Fourthkey
      type="password"
      maxlength="1"
      pattern="[0-9]"
      (input)="onKeyInput(4)"
      [(ngModel)]="key4"
    />
  </div>
  <button (click)="verify_AccessCode()">Verifier</button>
</div>
